var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLimit===false),expression:"isLimit===false"}],staticClass:"noLimit"},[_c('img',{attrs:{"src":require("@/assets/images/noLimit.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }